import React, { useEffect, useRef, useState } from 'react';
import './RadarEffect.css';

const RadarEffect = () => {
  const radarRef = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const radar = radarRef.current;
    if (!radar) return;

    // Track mouse position for interactive elements
    const handleMouseMove = (e) => {
      const rect = radar.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      
      setMousePos({ x, y });
      radar.style.setProperty('--mouse-x', `${x}%`);
      radar.style.setProperty('--mouse-y', `${y}%`);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="radar-container" ref={radarRef}>
      <div className="radar-sweep"></div>
      <div className="radar-grid">
        <div className="grid-line horizontal"></div>
        <div className="grid-line horizontal"></div>
        <div className="grid-line vertical"></div>
        <div className="grid-line vertical"></div>
      </div>
      <div className="radar-pulse"></div>
      <div className="target-lock"></div>
      <div className="cursor-highlight"></div>
    </div>
  );
};

export default RadarEffect;
